import { ContentHeader } from "../../components";
import { Form, Button, Input, Row, Col, Table, Space, Tag, TreeSelect } from 'antd';
import { DeleteOutlined, SaveOutlined, EditOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import Column from 'antd/es/table/Column';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { CauHinhPhuCapResponse } from "../../models/danhmuc/DanhMuc";
import { convertDataSelectBox, layCauHinhPhuCap, layDanhMucPhuCap, luuCauHinhPhuCap, xoaCauHinhPhuCap} from "@app/services/danhmuc";
import ModalTextForm from "@app/components/modal/ModalTextForm";
import { toast } from "react-toastify";
import { currencyFormat, formatVND, validateMessages } from '../../helpers/common';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { useDispatch } from 'react-redux';
import DonViSelectTree from "../utils/DonViSelectTree";
import ChucVuSelectBox from "../utils/ChucVuSelectBox";
import { DataSelectBox } from "../../models/selectbox";
import { PhuCapResponse } from "../../models/hopdong/HopDong";
import { searchLength } from "../../constants";

const CauHinhPhuCap = () => {
    const [data, setData] = useState<Array<CauHinhPhuCapResponse>>([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const menu: any = menuHelper.checkMultiPermission([Links.NhanVien.ChiTiet]);
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [isLoadingBtn, setIsLoadingBtn] = useState<boolean>(false);
    const [showModalChiTiet, setShowModalChiTiet] = useState<boolean>(false);
    const [optionPhuCap, setOptionPhuCap] = useState<Array<DataSelectBox>>([]);
    const [idXoa, setIdXoa] = useState<number>(0);
    const [form] = Form.useForm();
    const dispatch = useDispatch();

    const setFormDetailModal = (value: CauHinhPhuCapResponse | null) => {
        form.setFieldsValue({
            "id": value?.id || 0,
            "tenChucVu": value?.tenChucVu || "",
            "tenPhongBan": value?.tenPhongBan || "",
            "tenPhuCap": value?.tenPhuCap || "",
            "tienPhuCap": value?.tienPhuCap || 0,
            "idChucVu": value?.idChucVu == 0 ? null : value?.idChucVu,
            "idDonVi": value?.idDonVi == 0 ? null : value?.idDonVi,
            "idPhuCap": value?.idPhuCap,
            "tienPhuCapStr": value?.tienPhuCap ? currencyFormat.formatMoney(value?.tienPhuCap) : "",
        });
        setShowModalChiTiet(true);
    }

    const layDuLieu = async () => {
        try {
            setIsLoadingTable(true);
            let rs = await layCauHinhPhuCap();
            setData(rs);
            setIsLoadingTable(false);
        } catch (error: any) {
            setIsLoadingTable(false);
        };
    }

    const loadDataSelectBoxs = async () => {
        try {
            setLoading(true);

            var phuCap = await layDanhMucPhuCap();
            setOptionPhuCap(convertDataSelectBox(phuCap));
            setLoading(false);
        }
        catch (err: any) {
            setLoading(false);
        }
    }

    const onDelete = async () => {
        try {
            setIsLoadingBtn(true);
            await xoaCauHinhPhuCap(idXoa);
            toast.success('Xoá phụ cấp thành công!');

            // Tính toán số trang mới sau khi xóa
            const totalRecords = data.length - 1; // Số lượng bản ghi sau khi xóa
            let newPage = page;

            if (newPage > Math.ceil(totalRecords / searchLength)) {
                // Nếu trang hiện tại lớn hơn số trang mới tối đa
                newPage = Math.ceil(totalRecords / searchLength);
            }

            setPage(newPage);
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá không thành công!');
        }
        setIdXoa(0);
        setReloadPage(true);
        setIsLoadingBtn(false);
    }

    const onFinish = async (values: any) => {
        try {
            dispatch(showLoadingScreen());
            setIsLoadingBtn(true);
            values.idChucVu = values.idChucVu ?? 0;
            values.idDonVi = values.idDonVi ?? 0;
            await luuCauHinhPhuCap(values);
            toast.success('Lưu cấu hình phụ cấp thành công!')
        }
        catch (err: any) {
            
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }
        dispatch(hideLoadingScreen());
        setIsLoadingBtn(false);
        setReloadPage(true);
        setShowModalChiTiet(false);
    };

    const loctrunglapIdPhuCap = Array.from(new Set(data.map(item => item.idPhuCap)));

    const handleChangeCurrency = (e: any) => {
        e.preventDefault();
        const { value } = e.target;
        const parsedValue = value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
        var format = currencyFormat.formatMoney(parsedValue);
        form.setFieldsValue({
            tienPhuCap: parsedValue,
            tienPhuCapStr: format,
        });
    };

    useEffect(() => {
        if (reloadPage) {
            layDuLieu();
            setReloadPage(false);
        }
    }, [reloadPage]);

    useEffect(() => {
        loadDataSelectBoxs();
    }, [])

    return (<section>
        <ContentHeader title="Quản lý cấu hình phụ cấp" />

        {idXoa > 0 && <ModalTextForm show={idXoa > 0}
            title="Xoá cấu hình phụ cấp"
            handleClose={() => setIdXoa(0)}
            handleSave={onDelete}>
            Xác nhận xóa cấu hình đang chọn
        </ModalTextForm>}

        {!isLoadingBtn && showModalChiTiet && <ModalTextForm title="Cấu hình phụ cấp "
            hideFooter
            show={showModalChiTiet}
            handleClose={() => setShowModalChiTiet(false)}
        >
            <Form
                layout="vertical"
                validateMessages={validateMessages}
                onFinish={onFinish}
                form={form}
            >
                <Form.Item hidden name="id"><Input /></Form.Item>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Phòng ban"
                            name="idDonVi" >
                            <DonViSelectTree onChange={(e: any) => { form.setFieldValue('idDonVi', e.target.value); }} allowClear={true} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Chức vụ"
                            name="idChucVu" >
                            <ChucVuSelectBox onChange={(e: any) => { form.setFieldValue('idChucVu', e.target.value); }} allowClear={true} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item name="idPhuCap" label="Loại phụ cấp" rules={[{ required: true }]}>
                            <TreeSelect showSearch treeData={optionPhuCap} loading={loading} placeholder="Chọn phụ cấp"  />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Phụ cấp"
                            name="tienPhuCapStr" rules={[{ required: true }]} >
                            <Input prefix="₫ "
                                onChange={handleChangeCurrency}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item name="tienPhuCap" hidden>
                    <Input />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" loading={isLoadingBtn} className="float-right" htmlType="submit" icon=<SaveOutlined rev="" />>
                        Lưu
                    </Button>
                </Form.Item>
            </Form>
        </ModalTextForm>}

        <Row className="form-group" gutter={8}>
            <Col span={8}>
                <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên chức vụ, phòng ban, phụ cấp để tìm kiếm" onChange={(e) => {
                    setPage(1);
                    setTuKhoa(e.target.value)
                }} />
            </Col>
            <Col span={16}>
                <Button
                    className="hrm-btn hrm-btn-warning float-right"
                    onClick={() => {
                        setFormDetailModal(null);
                    }}
                    icon={<PlusOutlined rev="" />}
                >
                    Thêm mới
                </Button>
            </Col>
        </Row>
        <Row gutter={8}>
            <Col span={24}>
                <div className="card card-primary">
                    <Row>
                        <Col span={24}>
                            <Table
                                loading={isLoadingTable}
                                locale={{ emptyText: "Không có dữ liệu" }}
                                dataSource={data
                                    .map((item: any, index) => {
                                        item.key = index;
                                        return item;
                                    })
                                    .filter((record: CauHinhPhuCapResponse) => {
                                        const tenChucVuLowerCase = record.tenChucVu
                                            ? record.tenChucVu.toLowerCase()
                                            : "";
                                        const tenPhongBanLowerCase = record.tenPhongBan
                                            ? record.tenPhongBan.toLowerCase()
                                            : "";
                                        const tenPhuCapLowerCase = record.tenPhongBan
                                            ? record.tenPhuCap.toLowerCase()
                                            : "";
                                        return (
                                            tenChucVuLowerCase.includes(tuKhoa.toLowerCase()) ||
                                            tenPhongBanLowerCase.includes(tuKhoa.toLowerCase()) ||
                                            tenPhuCapLowerCase.includes(tuKhoa.toLowerCase())
                                        );
                                    })}
                                rowClassName={(record, index) => {
                                    return record?.id === idXoa ? "selected-row row-key-" : "";
                                }}
                                pagination={{
                                    current: page,
                                    onChange: (page, pageSize) => {
                                        setPage(page);
                                    },
                                }}
                            >
                                <Column
                                    title="STT"
                                    key="STT"
                                    align="center"
                                    render={(value, record, index) =>
                                    (
                                        <span key={"stt" + index}>
                                            {(page - 1) * searchLength + index + 1}
                                        </span>
                                    )
                                    }
                                />
                                <Column title="Tên phòng ban" dataIndex="tenPhongBan" key="tenPhongBan" />
                                <Column title="Tên chức vụ" dataIndex="tenChucVu" key="tenChucVu" />
                                <Column title="Loại phụ cấp" dataIndex="tenPhuCap" key="tenPhuCap"
                                    filters={loctrunglapIdPhuCap.map(idPhuCap => ({
                                        text: data.find(item => item.idPhuCap === idPhuCap)?.tenPhuCap,
                                        value: idPhuCap
                                    }))}
                                    onFilter={(value, record: PhuCapResponse) => record.idPhuCap === value}
                                />
                                <Column width="15%" title="Tiền phụ cấp" key="tienPhuCap" render={(value, record, index) =>
                                (
                                    <>
                                        {formatVND(value?.tienPhuCap)}
                                    </>
                                )
                                }
                                />
                                <Column
                                    title=""
                                    key="action"
                                    render={(value, record, index) =>
                                    (
                                        <Space>
                                            <Button type="primary" size={"small"} title="Sửa"
                                                icon=<EditOutlined rev="" />
                                                onClick={() => { setFormDetailModal(value); }}
                                            >
                                                Sửa
                                            </Button>
                                            <Button type="primary" danger size={"small"} title="Xóa"
                                                onClick={() => { setIdXoa(value.id) }}
                                                icon=<DeleteOutlined rev="" />
                                            >
                                                Xóa
                                            </Button>
                                        </Space>
                                    )
                                    }
                                />
                            </Table>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    </section>
    );
}
export default CauHinhPhuCap;